import { useCallback, useEffect, useState } from "react";
import { ToastTypes } from "../../../../../contexts/toastr.context";
import { useToast } from "../../../../../hooks/use-toast.hook";
import { Button } from "../../../../../_components";
import CurrencySelector from "../../../../../_components/compound/currency-selector";
import { CommunityService } from "../../../../../_service";
import { useAppService } from "../../../../../hooks/use-app-service";

type Status = "idle" | "loading" | "success" | "error";

interface ViewCommunityDefaultCurrencyProps {
  community: any;
  onCommunityUpdate: (community: any) => void;
}

/**
 * Component to display and update default currency
 * @param {any} community
 * @param {Function} onCommunityUpdate
 */
export default function ViewCommunityDefaultCurrency({
  community,
  onCommunityUpdate,
}: ViewCommunityDefaultCurrencyProps) {
  const { analyticsService } = useAppService();
  const COMMUNITY_DEFAULT_SUBSCRIPTION_CURRENCY =
    community?.configurables?.COMMUNITY_DEFAULT_SUBSCRIPTION_CURRENCY ?? "USD";

  const [status, setStatus] = useState<Status>("idle");
  const [currency, setCurrency] = useState("INR");

  const toast = useToast();

  // Initialize community default currency
  useEffect(() => {
    if (COMMUNITY_DEFAULT_SUBSCRIPTION_CURRENCY) {
      setCurrency(COMMUNITY_DEFAULT_SUBSCRIPTION_CURRENCY);
    }
  }, [COMMUNITY_DEFAULT_SUBSCRIPTION_CURRENCY]);

  // Update confirm button click
  const handleUpdateCurrency = useCallback(() => {
    updateCurrency(currency);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currency]);

  // Call api to update currency
  function updateCurrency(currency: string) {
    if (COMMUNITY_DEFAULT_SUBSCRIPTION_CURRENCY === currency) {
      console.log("currency is same");
      return;
    }
    setStatus("loading");
    CommunityService.updateConfigurable(
      community.id,
      "COMMUNITY_DEFAULT_SUBSCRIPTION_CURRENCY",
      currency
    )
      .then(() => {
        // Get configurables from community
        const { configurables } = community;
        // Update currency
        configurables.COMMUNITY_DEFAULT_SUBSCRIPTION_CURRENCY = currency;

        // update configurables in community
        onCommunityUpdate({ ...community, configurables });
        // show toast
        toast.addToast("Currency updated successfully");
        setStatus("success");
        analyticsService.track("currency-updated", {
          currency: currency
        })
      })
      .catch((err) => {
        console.error(err);
        toast.addToast(
          "Unable to update currency",
          "Refresh the app and try again",
          ToastTypes.danger
        );
        setStatus("error");
      });
  }

  return (
    <div className="mt-3 flex flex-row  gap-2 justify-between items-center">
      <CurrencySelector
        className="w-full"
        currency={currency}
        label="Default Currency for membership"
        onCurrencyChange={setCurrency}
      />
      <Button
        label="Confirm"
        isLoading={status === "loading"}
        disabled={currency === COMMUNITY_DEFAULT_SUBSCRIPTION_CURRENCY}
        className="outline-1 outline mt-6"
        onClick={handleUpdateCurrency}
      />
    </div>
  );
}
